import ContainedButton from './component.styles'
export default ContainedButton
